"use client";

import GradiantCard from "components/Cards/GradiantCard/GradiantCard";
import LinkHeading from "components/ComponentHeading/LinkHeading";
import typography from "components/typography";
import { cn } from "utils/functions";
import Image from "next/image";
import { usePathname } from "next/navigation";
type WhyLowCodeProps = {
  elementPosition: string | undefined;
  elementType: string | undefined;
  elementContentType: string | undefined;
  elementTitle: string | undefined;
  elementContent: any[];
  elementLink?: string;
  image?: string;
  isReversed?: boolean;
};
export default function WhyLowCodeV2({ json, type }: { json: WhyLowCodeProps[] | any; type: string }) {
  const pathname = usePathname();
  const isSpicyTakes = pathname?.includes("hot-takes-on-ai");
  const isReversed = json[0]?.isReversed;
  return (
    <div
      className={`grid gap-md lg:grid-cols-2 lg:gap-lg lg:py-md ${isReversed ? "lg:[grid-template-areas:'content_image']" : ""}`}
    >
      <div className={isReversed ? "lg:order-2" : ""}>
        {json.map((item: any, index: number) => {
          return (
            <div className="" key={index}>
              <LinkHeading
                headingType={"H2"}
                heading={item.elementTitle ?? ""}
                href={item.elementLink ?? ""}
                headingAdditionalClass={`group-hover:underline ${isSpicyTakes ? "group-hover:text-tertiary-orange-500" : "group-hover:text-tertiary-pink-500"} inline-block`}
                iconName="arrow"
                iconColorClass="text-primary-neutral-50"
                textAlign="text-left"
              />
              {item?.elementContent.map((content: any, index: number) => {
                return (
                  <p className={cn(typography.body.md, "pt-sm font-light")} key={index}>
                    {content?.text}
                  </p>
                );
              })}
            </div>
          );
        })}
      </div>
      <div className={`w-full rounded-xl bg-primary-neutral-100 ${isReversed ? "lg:order-1" : ""}`}>
        <Image className="w-full rounded-xl" src={json[0]?.image ?? ""} alt="placeholder" width={584} height={518} />
      </div>
    </div>
  );
}
